<template>
  <div class="work-list" data-automation="WorkList">
    <!-- 头部 -->
    <div class="work-list-header">
      <p class="work-list-header-title">{{ $t('HT.workList.list') }}</p>
      <ux-button
        v-if="$hasModule(81) && isUser"
        class="btn-addorder"
        type="primary"
        @click="onAddOrder"
        >{{ $t('HT.orderDetail.created') }}</ux-button
      >

      <div class="work-list-search">
        <ux-select
          class="work-list-search-state"
          v-model="searchData.state"
          :options="options.state"
        ></ux-select>
        <div class="work-list-search-read">
          <ux-button
            plain
            size="small"
            :type="searchData.read === '' ? 'primary' : 'info'"
            @click="searchData.read = ''"
            >{{ $t('HT.options.orderStatus1') }}</ux-button
          >
          <ux-button
            plain
            size="small"
            :type="searchData.read === '0' ? 'primary' : 'info'"
            @click="searchData.read = '0'"
            >{{ $t('HT.workList.noread') }}</ux-button
          >
        </div>
      </div>
    </div>

    <!-- 列表 -->
    <order-list
      ref="refOrderList"
      :order-data="orderData"
      :order-total="orderTotal"
      :is-loading="isLoading"
      @on-click-order="onClickOrder"
      @load-more="loadMore"
    ></order-list>

    <!-- 修改邮箱 -->
    <add-order-modal
      v-if="modalData.addOrder.isShow"
      @add-over="addOverCb"
      @close="modalData.addOrder.isShow = false"
    ></add-order-modal>
  </div>
</template>

<script>
import orderList from './orderList';
import addOrderModal from '../modal/addOrder';

export default {
  name: 'WorkList',
  components: {
    orderList,
    addOrderModal
  },
  props: {
    isUser: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      options: {
        state: [
          { label: this.$t('HT.options.orderStatus1'), value: '' },
          { label: this.$t('HT.orderList.state1'), value: '1' },
          { label: this.$t('HT.orderList.state2'), value: '2' },
          { label: this.$t('HT.orderList.state3'), value: '3' }
        ]
      },
      searchData: {
        state: '', // 回复状态
        read: '' // 已读状态 '0' | '1'
      },
      isGetlistIng: false,
      isLoading: false,
      orderTotal: 0, // 总条数
      modalData: {
        // 新建工单
        addOrder: {
          isShow: false
        }
      },
      userData: {}, // 用户信息
      currentOrder: null, // 当前点击的工单
      // 工单信息
      orderData: []
    };
  },

  created() {
    this.userData = this.$store.state.login.userData;
    this.getFirstList();
  },

  methods: {
    // 创建工单
    onAddOrder() {
      this.modalData.addOrder.isShow = true;
    },
    // 点击工单
    onClickOrder(idx) {
      this.orderData[idx].oldMsgStatus = this.orderData[idx].message_status;
      this.orderData[idx].message_status = '1';
      const order = this.orderData[idx]; // 点击的工单数据
      this.currentOrder = order;
      this.$emit('on-click-order', order);
    },
    // 工单结束
    overOrder() {
      const id = this.currentOrder.id;
      const idx = this.findIndex((item) => item.id === id);
      this.orderData[idx].order_status = '3'; // 关闭状态
    },
    // 创建工单结束回调
    addOverCb() {
      this.getFirstList(true);
    },
    // 获取第一页
    getFirstList(isAddOverCb) {
      if (this.isLoading) return;

      this.isLoading = true;
      this.$uxLoading.show();
      this.$set(this, 'orderData', []);
      this.getWorkOrderList()
        .then(() => {
          // 添加的回调
          if (isAddOverCb) {
            this.$nextTick(() => {
              this.$refs.refOrderList.onClickOrder(0);
            });
          }
        })
        .catch((err) => {
          const { sub_msg } = err.response.data || {};
          this.$uxMessage.error(sub_msg || this.$t('HT.workList.getError'));
        })
        .finally(() => {
          this.$uxLoading.hide();
          this.isLoading = false;
        });
    },

    // 获取列表
    getWorkOrderList() {
      const { id } = this.userData;
      const { state, read } = this.searchData;

      const num = Math.floor(this.orderData.length / 10);

      const params = {
        workStatus: state, // 回复状态
        massageStatus: read, // 已读状态
        userId: id,
        page: 1 + num, // 根据当前多少条自动判断
        size: 10
      };

      return this.$api.workOrder.getWorkOrderList(params).then((res) => {
        if (res.code == 10000) {
          const list = res.data.data || [];

          const mapList = list.map((item) => {
            return {
              ...item,
              imgNum: item.img ? item.img.split(',').length : 0
            };
          });
          this.orderData.push(...mapList);
          this.orderTotal = Number(res.data.total_size);
        }
      });
    },
    // 加载更多
    loadMore() {
      if (this.isLoading) return;

      this.isLoading = true;
      this.getWorkOrderList().finally(() => {
        this.isLoading = false;
      });
    }
  },
  watch: {
    searchData: {
      handler() {
        this.getFirstList();
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.work-list {
  background: #fff;
  height: 100%;
  display: flex;
  flex-direction: column;

  .work-list-header {
    box-sizing: border-box;
    position: relative;
    width: 100%;
    padding: 0 20px 14px;
    flex: 0 0 auto;

    .work-list-header-title {
      font-size: 18px;
      font-weight: 600;
      color: $color-title;
      line-height: 26px;
      padding: 24px 0 16px;
    }

    .btn-addorder {
      width: 100%;
      margin-bottom: 30px;
    }

    .work-list-search {
      display: flex;
      justify-content: space-between;
    }

    .work-list-search-read .ux-button {
      &:first-child {
        border-radius: 4px 0px 0px 4px;

        &.ux-button--info {
          border-right: 0;
        }
      }

      &:last-child {
        border-radius: 0px 4px 4px 0px;

        &.ux-button--info {
          border-left: 0;
        }
      }
    }

    ::v-deep .work-list-search-state {
      min-width: 76px;
      width: 76px;

      .el-input {
        height: 24px;
        min-height: 24px;

        .el-input__inner {
          height: 24px !important;
          line-height: 24px;
          font-size: 14px;
          color: $color-text;
          border-color: transparent;
          background: transparent;
          padding-left: 0;
        }
      }

      .el-input__icon {
        line-height: 24px;
      }
    }
  }

  .order-list {
    width: 100%;
    flex: 1;
    overflow: auto;
  }
}
</style>
